<template>
  <div class="year-picker" ref="picker">
    <div class="year-input" @click="toggleDropdown">
      <span>{{ value || 'Selecione o ano' }}</span>
      <i class="fa fa-caret-down" style="margin-left:8px;"></i>
    </div>
    <div v-if="open" class="year-dropdown">
      <button
        v-for="year in years"
        :key="year"
        :class="['year-btn', { selected: year === value }]"
        @click="selectYear(year)"
        type="button"
      >
        {{ year }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "YearPicker",
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    years() {
      const current = new Date().getFullYear();
      const start = 2023;
      const arr = [];
      for (let y = start; y <= current; y++) arr.push(y);
      return arr;
    }
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    selectYear(year) {
      this.$emit("input", year);
      this.$emit("change", year);
      this.open = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.picker.contains(event.target)) {
        this.open = false;
      }
    }
  },
  mounted() {
    document.addEventListener("mousedown", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
};
</script>

<style scoped>
.year-picker {
  position: relative;
  display: inline-block;
  width: 260px;
}
.year-input {
  border: 1px solid #dde2e7;
  border-radius: 4px;
  background: #fff;
  color: #6c757d;
  padding: 0 12px;
  min-height: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  user-select: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.year-input:focus,
.year-input:active {
  border-color: #6c757d;
  outline: none;
}
.year-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: #fff;
  border: 1px solid #6c757d;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-top: 2px;
  min-width: 100%;
  width: 100%;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
}
.year-btn {
  background: none;
  border: none;
  color: #333;
  padding: 8px 12px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.year-btn.selected,
.year-btn:hover {
  background: #007bff;
  color: #fff;
}
</style>
